var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVilleInclusive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.28,60.94c24.87-29.81-15.89-68.24-44.19-41.49l-12.1,12.1-9.33-9.33-2.64,2.64,10.1,10.1v3.53h-1.88c-5.32-.02-9.61,4.51-9.33,9.82.22,4.94,4.44,8.88,9.29,8.86h1.91v3.75h-18.7v5.61c0,3.09-2.52,5.61-5.61,5.61s-5.61-2.52-5.61-5.61v-5.61H12.89C-13.28,35.43,22.36-2.41,49.24,22.09l2.64-2.64C23.29-7.21-17.04,30.83,7.69,60.94l56.29,56.63,16.28-16.53-2.64-2.64-11.76,11.76v-19.31h1.87c5.15,0,9.35-4.19,9.35-9.35s-4.19-9.35-9.35-9.35h-1.87v-7.48h18.7v-5.61c0-3.09,2.52-5.61,5.61-5.61s5.61,2.52,5.61,5.61v5.61h15.57l-30.98,30.98,2.64,2.64,37.28-37.36Zm-52.56,14.96c3.09,0,5.61,2.52,5.61,5.61s-2.52,5.61-5.61,5.61h-5.61v23.05l-45.48-45.49h11.83v1.87c0,5.15,4.19,9.35,9.35,9.35s9.35-4.19,9.35-9.35v-1.87h14.96v11.22h5.61Zm31.78-14.96v-1.87c0-5.15-4.19-9.35-9.35-9.35s-9.35,4.19-9.35,9.35v1.87h-14.96v-7.47l-5.64-.02c-3.08-.01-5.58-2.52-5.58-5.6s2.51-5.6,5.6-5.6h5.62v-7.27l12.88-12.88c26.75-24.61,62.58,13.68,36.35,38.85h-15.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.25,21.68h3.74v3.74h-3.74v-3.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.73,21.68h3.74v3.74h-3.74v-3.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.55,21.68h3.74v3.74h-3.74v-3.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.9,68.42h3.74v3.74h-3.74v-3.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.07,68.42h3.74v3.74h-3.74v-3.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilleInclusive);
export default __webpack_public_path__ + "static/media/ville-inclusive.739b0dff1f9fbec80d0785beb88d039c.svg";
export { ForwardRef as ReactComponent };